module.exports = __webpack_public_path__ + "static/media/icon_2.4e8a64a7.png";